// Copyright 2022, Imprivata, Inc.  All rights reserved.

import classes from './CenteringContainer.module.css';

export const CenteringContainer: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return <div className={classes.container}>{children}</div>;
};
